
export const NODE_ENV_TYPE_DEVELOPMENT = "development"
export const NODE_ENV_TYPE_PRODUCTION = "production"
export const nullStrRegex = /^\s*$/
export const API_DEV_URL = 'https://apidev.bmktech.vn'
export const API_SIT_URL = 'https://apisit.bmktech.vn'

export class CommonUtils {
	static removeSpecialCharNumberPlate(value) {
		return value ? value.replace(/[^a-zA-Z0-9.-]/g, '') : ''
	}

	static removeSpecialChar(value) {
		return value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[]\\\/]/gi, '')
	}

	static getValueInRange(value, max) {
		if (!value) {
			return value
		}
		return +value >= max ? max : value
	}

	static numberFormat = (value) => {
		return Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value)
	}

	static isObject = (item) => {
		return (typeof item === 'object' && !Array.isArray(item) && item !== null)
	}

	static isValueEmpty = (potentialInput) => {
		if (Array.isArray(potentialInput)) return true
		if (CommonUtils.isObject(potentialInput)) return true
		const _potentialInput = potentialInput?.toString()
		return !!(!_potentialInput || _potentialInput.match(nullStrRegex));

	}

	static isValueNumber = (potentialInput) => {
		if (Array.isArray(potentialInput)) return false
		if (CommonUtils.isObject(potentialInput)) return false
		if (CommonUtils.isValueEmpty(potentialInput)) return false
		return !isNaN(potentialInput);

	}

	static isObjEmpty = (obj) => {
		if (!obj) return true
		for (let prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false
			}
		}
		return true
	}

	static isArrayEmpty = (arr) => {
		if (!arr) return true
		return !(Array.isArray(arr) && arr.length > 0);

	}

	static generateUUID = () => {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c === 'x' ? r : r & 0x3 | 0x8;
			return v.toString(16);
		});
	};
}